import React from "react";
import PropTypes from "prop-types";
import { Grid2 } from "@mui/material";
// styles
import styles from "./EmptyState.module.scss";
import EmptyButton from "./EmptyButton/EmptyButton";
import CreateHeader from "./CreateHeader/CreateHeader";
import { ReactComponent as NewOrgImage } from "../../Features/Admin/AdminAssets/svg/NewOrganization.svg";

export default function EmptyState({
  header,
  subHeader,
  title,
  subTitle,
  icon: Icon,
  create,
  onClick,
  docsheader,
  docsSubheader,
  docsbutton,
  docsbuttonOnclick,
  title1,
  subTitle1,
  subTitle2,
  subTitle3,
  liveHeader,
  liveSubheader,
  livebuttonOnclick,
  liveButton,
}) {
  return (
    <Grid2 className={styles.emptyStateContainer}>
      <Grid2 className={styles.headerFlexBox}>
        <Grid2 className={styles.width}>
          <Grid2 className={styles.header}>{header}</Grid2>
          <Grid2 className={styles.subHeader}>{subHeader}</Grid2>
        </Grid2>
        <Grid2 className={styles.create} onClick={onClick}>
          {create}
        </Grid2>
      </Grid2>
      <Grid2 className={styles.ImageContainer}>
        <Grid2 className={styles.headerText}>
          <Grid2 className={styles.widthText}>
            <Grid2 className={styles.title}>{title}</Grid2>
            <Grid2 className={styles.desc}>{subTitle}</Grid2>
          </Grid2>
          <Grid2 className={styles.image}>
            {Icon ? (
              <Icon className={styles.OrgImage} />
            ) : (
              <NewOrgImage className={styles.OrgImage} />
            )}
          </Grid2>
        </Grid2>
        <Grid2>
          <Grid2 className={styles.title1}>{title1}</Grid2>
          <Grid2 className={styles.descFlexbox}>
            <CreateHeader Desc={subTitle1} />
            <CreateHeader Desc={subTitle2} />
            <CreateHeader Desc={subTitle3} />
          </Grid2>
        </Grid2>
      </Grid2>
      <EmptyButton
        header={docsheader}
        subHeader={docsSubheader}
        buttonOnclick={docsbuttonOnclick}
        buttonLabel={docsbutton}
      />
      {/* <EmptyButton
        header={liveHeader}
        subHeader={liveSubheader}
        buttonOnclick={livebuttonOnclick}
        buttonLabel={liveButton}
      /> */}
    </Grid2>
  );
}

EmptyState.propTypes = {
  header: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
  icon: PropTypes.elementType.isRequired,
};
